import React from "react";

import {
  Admin,
  Resource,
  ShowGuesser,
  //   EditGuesser,
} from "react-admin";

import { myDataProvider } from "../dataProvider/dataProvider";
import reducer from "../reducer";

import customRoutes from "../routes";

import { ManagerLayout } from "./layout/ManagerLayout";
import { ManagerDashboard } from "./layout/ManagerDashboard";

import { AccountList } from "./resources/accounts/AccountList";
import { AccountCreate } from "./resources/accounts/AccountCreate";
import { AccountEdit } from "./resources/accounts/AccountEdit";
import { AccountShow } from "./resources/accounts/AccountShow";

import { AuditList } from "./resources/audits/AuditList";
import { AuditCreate } from "./resources/audits/AuditCreate";
import { AuditEdit } from "./resources/audits/AuditEdit";

import { InvoiceList } from "./resources/invoices/InvoiceList";
import { InvoiceCreate } from "./resources/invoices/InvoiceCreate";
import { InvoiceEdit } from "./resources/invoices/InvoiceEdit";
import { InvoiceShow } from "./resources/invoices/InvoiceShow";

import { MyYardShow } from "./resources/reloadYard/ReloadYardShow";
import { MyYardEdit } from "./resources/reloadYard/ReloadYardEdit";
import AisleEdit from "./resources/reloadYard/layout/AisleEdit";

import { InboundList } from "./resources/inboundShipments/InboundList";
import { InboundCreate } from "./resources/inboundShipments/InboundCreate";
import { InboundEdit } from "./resources/inboundShipments/InboundEdit";
import { InboundShow } from "./resources/inboundShipments/InboundShow";

import { OutboundList } from "./resources/outboundShipments/OutboundList";
import { OutboundCreate } from "./resources/outboundShipments/OutboundCreate";
import { OutboundEdit } from "./resources/outboundShipments/OutboundEdit";
import { OutboundShow } from "./resources/outboundShipments/OutboundShow";
import { PickListItemEdit } from "./resources/outboundShipments/lineItem/PickListItemEdit";

import { InventoryList } from "./resources/inventory/InventoryList";
import { InventoryEdit } from "./resources/inventory/InventoryEdit";
import { InventoryShow } from "./resources/inventory/InventoryShow";
import { InventoryItemCreate } from "./resources/inventory/inventoryItems/InventoryItemCreate";
import { InventoryItemEdit } from "./resources/inventory/inventoryItems/InventoryItemEdit";
import { InventoryItemShow } from "./resources/inventory/inventoryItems/InventoryItemShow";
import { WorkOrderCreate } from "./resources/workOrders/WorkOrderCreate";
import { WorkOrderList } from "./resources/workOrders/WorkOrderList";

import { UserList } from "./resources/users/UserList";
import { UserCreate } from "./resources/users/UserCreate";
import { UserEdit } from "./resources/users/UserEdit";
import { UserShow } from "./resources/users/UserShow";

import { CarrierList } from "./resources/carriers/CarrierList";
import { CarrierEdit } from "./resources/carriers/CarrierEdit";
import { CarrierCreate } from "./resources/carriers/CarrierCreate";
import { CarrierUserCreate } from "./resources/carriers/users/CarrierUserCreate";
import { CarrierUserList } from "./resources/carriers/users/CarrierUserList";
import { CarrierUserEdit } from "./resources/carriers/users/CarrierUserEdit";

import { CustomerList } from "./resources/customers/CustomerList";
import { CustomerCreate } from "./resources/customers/CustomerCreate";
import { CustomerEdit } from "./resources/customers/CustomerEdit";
// import { UserShow } from "./resources/users/UserShow";

import { FileCreate } from "./resources/files/FileCreate";
import { FileEdit } from "./resources/files/FileEdit";
import { FileList } from "./resources/files/FileList";

import { ProductCreate } from "./resources/products/ProductCreate";
import { ProductEdit } from "./resources/products/ProductEdit";
import { ProductList } from "./resources/products/ProductList";

import { ServiceEdit } from "./resources/services/ServiceEdit";
import { ServiceCreate } from "./resources/services/ServiceCreate";
import { ChargeRuleCreate } from "./resources/accounts/chargeRules/ChargeRuleCreate";
import { ChargeRuleEdit } from "./resources/accounts/chargeRules/ChargeRuleEdit";

import { TaskList } from "./resources/tasks/TaskList";
import { TaskCreate } from "./resources/tasks/TaskCreate";
import { TaskEdit } from "./resources/tasks/TaskEdit";

import { useThemeState } from "../ThemeStateProvider";

import { EventTypeCreate } from "./resources/eventTypes/EventTypeCreate";
import { EventTypeEdit } from "./resources/eventTypes/EventTypeEdit";
import { ChecklistCreate } from "./resources/checklists/ChecklistCreate";
import { ChecklistEdit } from "./resources/checklists/ChecklistEdit";
import { AssetTypeCreate } from "./resources/assetTypes/AssetTypeCreate";
import { AssetTypeEdit } from "./resources/assetTypes/AssetTypeEdit";

export const ManagerApp = ({ adminHistory }) => {
  const { selectedTheme } = useThemeState();

  return (
    <Admin
      disableTelemetry
      title="Transloads.co"
      dashboard={ManagerDashboard}
      options={{ authGroups: [] }}
      dataProvider={myDataProvider}
      layout={ManagerLayout}
      customRoutes={customRoutes}
      customReducers={{ data: reducer }}
      theme={selectedTheme}
      history={adminHistory}
    >
      <Resource
        title={"Inbound Shipments"}
        name="inboundShipments"
        list={InboundList}
        create={InboundCreate}
        edit={InboundEdit}
        show={InboundShow}
      />
      <Resource
        name="outboundShipments"
        list={OutboundList}
        create={OutboundCreate}
        edit={OutboundEdit}
        show={OutboundShow}
      />
      <Resource name="shipmentLineItems" edit={PickListItemEdit} />
      <Resource
        name="inventories"
        list={InventoryList}
        show={InventoryShow}
        edit={InventoryEdit}
      />
      <Resource
        name="inventoryItems"
        create={InventoryItemCreate}
        edit={InventoryItemEdit}
        show={InventoryItemShow}
      />
      <Resource
        title={"Work Orders"}
        name="workOrders"
        list={WorkOrderList}
        create={WorkOrderCreate}
      />
      <Resource name="workOrderItems" />
      <Resource
        name="audits"
        list={AuditList}
        create={AuditCreate}
        show={ShowGuesser}
        edit={AuditEdit}
      />
      <Resource
        name="accounts"
        list={AccountList}
        create={AccountCreate}
        show={AccountShow}
        edit={AccountEdit}
      />
      <Resource
        name="invoices"
        list={InvoiceList}
        create={InvoiceCreate}
        show={InvoiceShow}
        edit={InvoiceEdit}
      />
      <Resource name="reloadYards" show={MyYardShow} edit={MyYardEdit} />
      <Resource name="aisles" edit={AisleEdit} />
      <Resource name="services" edit={ServiceEdit} create={ServiceCreate} />
      <Resource
        name="users"
        list={UserList}
        create={UserCreate}
        show={UserShow}
        edit={UserEdit}
      />
      <Resource
        name="carriers"
        list={CarrierList}
        create={CarrierCreate}
        edit={CarrierEdit}
      />
      <Resource
        name="carrierUsers"
        list={CarrierUserList}
        create={CarrierUserCreate}
        edit={CarrierUserEdit}
      />
      <Resource
        name="customers"
        list={CustomerList}
        create={CustomerCreate}
        edit={CustomerEdit}
        // show={UserShow}
      />
      <Resource
        title={"Tasks"}
        name="tasks"
        list={TaskList}
        create={TaskCreate}
        edit={TaskEdit}
      />
      <Resource
        title={"Documents"}
        name="files"
        list={FileList}
        create={FileCreate}
        edit={FileEdit}
      />
      <Resource
        title={"Product Catalog"}
        name="products"
        create={ProductCreate}
        edit={ProductEdit}
        list={ProductList}
      />
      <Resource
        title={"Asset Types"}
        name="assetTypes"
        create={AssetTypeCreate}
        edit={AssetTypeEdit}
      />
      <Resource
        title={"Event Types"}
        name="eventTypes"
        create={EventTypeCreate}
        edit={EventTypeEdit}
      />
      <Resource
        title={"Checklists"}
        name="checklists"
        create={ChecklistCreate}
        edit={ChecklistEdit}
      />
      <Resource
        title={"Charge Rules"}
        name="chargeRules"
        create={ChargeRuleCreate}
        edit={ChargeRuleEdit}
      />
      <Resource name="areas" />
      <Resource name="zones" />
      <Resource name="locations" />
      <Resource name="capabilitys" />
      <Resource name="commoditys" />
      <Resource name="reloadYardCommoditys" />
      <Resource name="reloadYardCapabilitys" />
    </Admin>
  );
};
